import router from "@/router";

/**
 *封装路由跳转功能
 *@String | Json params: 路由跳转参数
 *@Boolean isRefresh: 跳转过去的页面是否需要刷新
 */
export default (params, isRefresh = true) => {
  const cached = new Date().getTime();
  if (typeof params == "string") {
    if (isRefresh) {
      let reg = /cached=\d+/g;
      if (reg.test(params)) {
        //如果原本有cached 就替换
        params = params.replace(reg, `cached=${cached}`);
      } else {
        if (params.indexOf("?") != -1) {
          //如果路由有查询值
          params = `${params}&cached=${cached}`;
        } else {
          params = `${params}?cached=${cached}`;
        }
      }
    }
    router.push(params);
    return Promise.resolve();
  }
  if (isRefresh) {
    //跳转过去的页面需要刷新
    if (!params.query) {
      params.query = {};
    }
    params.query.cached = cached;
  }
  if (params.type == "replace") {
    router.replace(params);
  } else {
    router.push(params);
  }
  return Promise.resolve();
};
